// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-unsafe-return */

import moment from "moment";
import React from "react";
import { FlightLogData } from "../../../../apis/types/flightTypes";
import { useModuleNavigation } from "../../../../hooks/useModuleNavigation.js";
import ResultsTable from "../../../Lumber/Search/ResultsTable";
import { AnyFilter } from "../../../Lumber/Search/types";
import { useUserAuth } from "../../../../hooks/useUserAuth";
import { ApplicationArea } from "../../../Lumber/ApplicationAreas";
import _ from "lodash";

interface Props {
	loading: boolean;
	data: FlightLogData[];
	filters: { [key in keyof FlightLogData]?: AnyFilter };
	searchTerm: { term: string; cols: (keyof FlightLogData)[] };
	// setData: React.Dispatch<React.SetStateAction<FlightLogData[]>>;
}

export const FlightSearchResults = ({ data, loading, filters, searchTerm }: Props) => {
	const moduleNavigation = useModuleNavigation();
	const userAuth = useUserAuth();

	const headers = {
		name: "Flight Name",
		dateAndTime: "Flight Date",
		flightParameters: "Flight Parameters",
		flightConditions: "Flight Conditions",
		// clientName: "Client",
		// cooperators: "Cooperators",
		operator: "Operator",
		farms: "Farms",
		fieldsPlaced: "Fields",
		uas: "UAS",
		growingSeasons: "Growing Seasons",
		orthoImages: "Image Upload",
		plotAnalysis: "Plot Analysis",
	};

	return (
		<ResultsTable<FlightLogData>
			level="flight"
			loading={loading}
			data={data}
			headers={headers}
			onRenderDataColumn={{
				flightParameters: (fp) => ({
					options: { breaks: true },
					render: [
						`Altitude: ${fp.altitude ? fp.altitude + " ft." : "-"}`,
						`Drone Speed: ${fp.droneSpeed ? fp.droneSpeed + " mph" : "-"}`,
					],
				}),
				flightConditions: (fc) => ({
					options: { breaks: true },
					render: [
						`Pauses: ${fc.inFlightPauses !== null ? (fc.inFlightPauses ? "Yes" : "No") : "-"}`,
						`Wind Speed: ${fc.windSpeed ? fc.windSpeed + " mph" : "-"}`,
						`Cloud Coverage: ${fc.cloudCoverage ?? "-"}`,
					],
				}),
				cooperators: (cs) => (cs ? _.map(cs, (c) => c.cooperatorName) : "-"),
				farms: (fs) => (fs ? _.map(fs, (f) => f.name) : "-"),
				fieldsPlaced: (fp) => (fp.total !== null ? `${fp.count}/${fp.total}` : `${fp.count}`),
				growingSeasons: (gs) => (gs ? _.map(gs, (g) => g.name) : "-"),
				orthoImages: (ois) =>
					_.reduce(ois, (acc, oi) => (oi.isUploading || oi.uploaded ? [...acc, oi.abbreviation] : acc), [] as string[]),
			}}
			onSortColumn={{
				name: true,
				dateAndTime: (a, b) => moment(b, "MM/DD/YYYY h:mma").diff(moment(a, "MM/DD/YYYY h:mma")),
				clientName: true,
				operator: true,
				uas: true,
				plotAnalysis: true,
			}}
			columnFilters={filters}
			actions={[
				{
					hasArea: (row) => userAuth.hasApplicationArea(ApplicationArea.FlightEdit, row.clientId),
					title: "Edit",
					icon: "pencil",
					to: (row) => moduleNavigation.createFlightLink(false, row.flightId, "info"),
				},
				{
					hasArea: (row) => userAuth.hasApplicationArea(ApplicationArea.FlightPlotAnalysis, row.clientId),
					title: "Plot Analysis",
					icon: "chart bar outline",
					to: (row) => moduleNavigation.createFlightLink(false, row.flightId, "plot-analysis"),
				},
			]}
			links={{
				name: (row) =>
					row.uas === "Vector Data"
						? moduleNavigation.createFlightLink(false, row.flightId, "data-layer-upload")
						: moduleNavigation.createFlightLink(false, row.flightId, "viewer"),
			}}
			searchTerm={searchTerm}
			initialSortColumn={"dateAndTime"}
		/>
	);
};
